import { enMediaType, IWatch } from "../../../../interfaces/watch";
import Audio from "./Audio";
import Video from "./Video";
import Youtube from "./Youtube";

interface IMediaTypeProps {
  watchInfo: IWatch;
}

const FallbackComponent = () => <></>;

const MediaType = (props: IMediaTypeProps) => {
  const mapper: Record<string, any> = {
    [enMediaType.AUDIO]: Audio,
    [enMediaType.VIDEO]: Video,
    [enMediaType.YOUTUBE]: Youtube,
  };

  const ComponentMapper = mapper[props.watchInfo.type] ?? FallbackComponent;

  return <ComponentMapper {...props} />;
};

export default MediaType;
